import { isInViewport } from '../../../../application/typescript/utils/utils';

class BlockHomeParcourir {
  constructor() {
    this._init();
  }

  _init() {
    const parcourir = document.getElementById("home-parcourir")
    if (parcourir) {
      window.addEventListener("scroll", function () {
        if (isInViewport(parcourir)) {
          parcourir?.classList.add('scrolled')
        }
      });
    }
  }



}
export const blockHomeParcourir = new BlockHomeParcourir();
